import { Component, OnInit } from "@angular/core";
import { Platform } from "@ionic/angular";
import { Navigator } from "src/app/components/menu/navigator";
import { AppstorageTsService } from "src/app/services/appstorage/appstorage.ts.service";
import { ConfigService } from "src/app/services/config/config.service";
import { SiteLocationService } from "src/app/services/site-location/site-location.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { MobileToolsService } from "src/app/services/mobile-tools/mobile-tools.service";
import { MarketingService } from 'src/app/services/marketing/marketing.service';
import { UtilsService } from "src/app/services/utils/utils.service";
import { UniqueIDService } from "src/app/services/unique-id/unique-id.service";
import { EventsService } from "src/app/services/event/event.service";
import { App } from '@capacitor/app';
import { JurisdictionService } from "src/app/services/geo/jurisdiction.service";
import { LocationWarningService } from "src/app/services/location-warning/location-warning.service";

@Component({
  selector: "app-tab-landing",
  templateUrl: "./tab-landing.page.html",
  styleUrls: ["./tab-landing.page.scss"],
})

export class TabLandingPage implements OnInit {
  public isAuthenticated: boolean = false;
  public splashPageSettings;
  public displayButtons: Boolean = true;
  public splashPageState = '';
  public isMobile: Boolean = false;
  public isMobileApp: boolean = false;
  public versionNumber: string;

  public currentYear: any;
  public stateName = "";
  private timeout = 1000;
 
  public tapCount: number = 0;
  public tapTimeoutID: any = 0;
  public deviceId: any;
  public environment: any = "";
  public showDeviceId: boolean = false
  public isEnvSelected: boolean = false;
  public statesMap:{[key:string]:string};

  public displayLoadingText:Boolean = true; 

  public mobileStyle:string;
  constructor(
    public config: ConfigService, 
    public platform: Platform,
    public navigator: Navigator,
    public userSessionService: UserSessionService,
    public utils: UtilsService,
    public siteLocationService: SiteLocationService,
    // public screenOrientation: ScreenOrientation,
    private appstorageTsService: AppstorageTsService,
    private mobileTools: MobileToolsService,
    private uniqueIDProvider: UniqueIDService,
    private events: EventsService,
    private marketingService: MarketingService,
    private geoJurisdictionService: JurisdictionService,
    private locationWarningService:LocationWarningService
  ) {
    this.currentYear = new Date().getFullYear();
    this.statesMap = this.siteLocationService.statesMap;
    this.mobileStyle = this.platform.is('mobile') ? 'mobile' : '';
    // this.mobileStyle += this.screenOrientation.type == 'portrait-primary' ? " from-portait" : " from-landscape";
  }


  async ngOnInit() { 
    this.isMobile = this.platform.is('mobile');
    if (this.platform.is('capacitor')) {
      await this.checkDeviceId();
      await this.checkEnvironmentSelector();

      if (this.platform.is("android")) {
        const locationWarningCheck = this.config.getConfig().FEATURE_LOCATION_WARNING_CHECK === "1" ? true : false;
        if(locationWarningCheck){
           this.locationWarningService.initGeoVerificationProcess();
        } else {
         this.mobileTools.requestAndroidGeoPermissions();
        }
       }
    }
  }

  async checkDeviceId() {
    const info = await App.getInfo()
      this.versionNumber = info.version;

      this.uniqueIDProvider.getSelectorID().then(
        response => {
          console.log("uniqueIDProvider.getSelectorID()", response)
          this.deviceId = response
        },
        reject => {
          console.log("error uniqueIDProvider.getSelectorID()", reject)
          this.deviceId = "Not available!"
        }
      );
  }

  async checkEnvironmentSelector() {
     await this.mobileTools.checkEnvironmentSelector()
     if (this.mobileTools.shouldSelectEnvironment) {
        this.showDeviceId = true;
     }
     else {
      this.splashPageInit();
    }
  }

  private splashPageInit() {
    console.log("TabLandingPage splashPageInit");

      this.checkLoadText();
      this.getSplashPageConfigs();
      setTimeout(() => {
        this.siteLocationService.goTo("casino", "ON", this.environment);
      }, this.timeout);
    // this.marketingService.initialize();
  }

  private checkLoadText() {
    let pageSettings = this.config.getConfig().FEATURE_APP_SPLASH_SETTINGS;
    let pageSettingList: any = pageSettings && JSON.parse(pageSettings);
    // if the displayLoadingText exist and displayLoadingText == 0, will the hide the text
    this.displayLoadingText =
      pageSettingList &&
      !pageSettingList.some((i) => i.displayLoadingText == "0");
  }

  public getSplashPageConfigs() {
    let pageSettings = this.config.getConfig().FEATURE_APP_SPLASH_SETTINGS;
    this.splashPageSettings = pageSettings && JSON.parse(pageSettings);
  }
  // environment selector logic 
  onLogoTap() {
    if (this.platform.is('capacitor')) {
      this.tapCount += 1;
      // console.log("environment-selector onLogoTap", this.tapCount)

      clearTimeout(this.tapTimeoutID);

      if (this.tapCount >= 10) {
        this.showDeviceId = true
      }
      else {
        this.tapTimeoutID = setTimeout(() => {
          this.tapCount = 0;
        }, 5000)
      }
    }
  }

  selectEnv(value: string) {
    console.log(`Selected environment: ${value}`);
    this.environment = value;
    this.onEnvChange(); 
  }

  onEnvChange() {
    console.log('environment-selector onEnvChange', this.environment);
  }

  onGoToEnvironment() {
    console.log('environment-selector onGoToEnvironment', this.environment);

    this.isEnvSelected = true
   //n this.config.reloadConfig(this.environment); 
    this.config.isLoaded().then(()=>{
      console.log("config reloaded", this.environment);
      this.siteLocationService.goTo("", "ON", this.environment);
    })
  }

  isEnvironmentSelected() {
    return this.environment != "" ? true : false;
  }
  //end environment selector logic
}
